import { UrlBuilder } from "../../domain/usecase/url-builder";

export class BuildUrl implements UrlBuilder {
  build(link: string, params: Record<string, string>): string {
    if (!link) return "";

    const query = new URLSearchParams(params).toString();
    if (!query) return link;

    if (link.startsWith("#")) return link;

    if (link.match(/\?/)) {
      return `${link}&${query}`;
    }
    return `${link}?${query}`;
  }
}
